import slideLogo1 from '../../assets/images/icon/star-icon.png';
export default function SlidingText() {

  return (
    <>
      {/* Sliding Text Start */}
      <section className="sliding-text-one">
          <div className="sliding-text-one__wrap">
          <ul className="sliding-text__list marquee_mode">
              <li>
              <h2 data-hover="Custom Apparel" className="sliding-text__title">
                  Custom Apparel
                  <img src={slideLogo1} alt="Star Icon" />
              </h2>
              </li>
              <li>
              <h2 data-hover="Promotional Products" className="sliding-text__title">
                  Promotional Products
                  <img src={slideLogo1} alt="Star Icon" />
              </h2>
              </li>
              <li>
              <h2 data-hover="Corporate Gifts" className="sliding-text__title">
                  Corporate Gifts
                  <img src={slideLogo1} alt="Star Icon" />
              </h2>
              </li>
              <li>
              <h2 data-hover="Trade Show Giveaways" className="sliding-text__title">
                  Trade Show Giveaways
                  <img src={slideLogo1} alt="Star Icon" />
              </h2>
              </li>
              <li>
              <h2 data-hover="Team Merchandise" className="sliding-text__title">
                  Team Merchandise
                  <img src={slideLogo1} alt="Star Icon" />
              </h2>
              </li>
              <li>
              <h2 data-hover="Branded Office Supplies" className="sliding-text__title">
                  Branded Office Supplies
                  <img src={slideLogo1} alt="Star Icon" />
              </h2>
              </li>
          </ul>
          </div>
      </section>
      {/* Sliding Text End */}
    </>
  );
}
